
import { Rarity } from "@alienheadwars/football-card-manager-model";
import { motion } from 'framer-motion'; // Import motion
import React from "react";

const rarityGlowColors: Partial<Record<Rarity, string>> = {
    [Rarity.UNCOMMON]: '#28a745',
    [Rarity.RARE]: '#007bff',
    [Rarity.EPIC]: '#9d00ff',
    [Rarity.LEGENDARY]: '#ff8c00',
    [Rarity["GOD-TIER"]]: '#ff0000',
};

interface RarityGlowProps {
    rarity: Rarity,
    style?: React.CSSProperties
}

export const RarityGlow = (props: RarityGlowProps) => {
    const glowColor = rarityGlowColors[props.rarity];

    const initialShadowState = glowColor ? {
         boxShadow: `0 0 0rem 0rem ${glowColor}`
    } : {};

    const animateShadowState = glowColor ? {
        boxShadow: [
            `0 0 0.1rem 0.1rem ${glowColor}`,
            `0 0 0.6rem 0.2rem ${glowColor}`,
            `0 0 0.1rem 0.1rem ${glowColor}`,
        ],
    } : {};

    const transitionShadowState = glowColor ? {
        boxShadow: {
            delay: 1,         
            duration: 4,     
            repeat: Infinity,  
            repeatDelay: 2,   
            ease: "easeInOut",
        }
    } : undefined;
    return <motion.div
        style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 0,
            ...(props.style ??{}),
        }}
        initial={initialShadowState}
        animate={animateShadowState}
        transition={transitionShadowState}
    />
}